<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('gestao', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
            ref='multipleTable',
            @selection-change='handleSelectionChange',
            :table-layout='tableLayout'
        )
            el-table-column(
                type='selection',
                :selectable='camposSelecionaveis',
                v-if='removendo',
                align='center',
                width='45',
                fixed='left'
            )

            el-table-column(
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.numeroContrato")',
                sortable,
                :min-width='getColumnWidth("numeroContrato")',
                show-overflow-tooltip
            )
                .template(slot-scope='scope')
                    span {{ formatarNumeroContrato(scope.row.numeroContrato) }}
            el-table-column(
                v-if='isBe8',
                prop='codigoExterno',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.codigoExterno")',
                align='left',
                width='300'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.codigoExterno || '-' }}

            el-table-column(
                prop='subEmpresaNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.fornecedor")',
                :min-width='getColumnWidth("nomeVendedor")',
                show-overflow-tooltip,
                sortable
            )
            el-table-column(
                prop='materialNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.cultura")',
                sortable,
                :min-width='getColumnWidth("materialNome")',
                show-overflow-tooltip
            )
            el-table-column(
                prop='safraNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.safra")',
                sortable,
                :min-width='getColumnWidth("safraNome")',
                show-overflow-tooltip
            )
            el-table-column(
                prop='volumeContratado',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.volumeContratado")',
                sortable='custom',
                :min-width='getColumnWidth("volumeContratado")',
                show-overflow-tooltip
            )
                .template(slot-scope='scope')
                    span {{ scope.row.volumeContratado + ' t' }}
            el-table-column(
                prop='dataContrato',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.dataContrato")',
                sortable,
                :min-width='getColumnWidth("dataContrato")',
                show-overflow-tooltip
            )
            el-table-column(
                prop='eudr',
                label='EUDR',
                sortable,
                :min-width='getColumnWidth("eudr")',
                show-overflow-tooltip
            )
                .template(slot-scope='scope')
                    span {{ eudrFormatado(scope.row.eudr) }}
            el-table-column(
                prop='statusEmpresa',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.statusEmpresa")',
                sortable,
                :min-width='getColumnWidth("statusEmpresa")',
                show-overflow-tooltip
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusEmpresa }}
                    .status-processamento__dias(v-if='scope.row.dataHa')
                        i.mdi.mdi-clock-outline
                        | {{ scope.row.dataHa }}

            el-table-column(
                label='',
                align='center',
                width='45',
                fixed='right'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.visualizarContrato') }}

                            el-dropdown-item(
                                v-if='codigosEdicao[scope.row.statusEmpresaCodigo]',
                                @click.native='editarContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-square-edit-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.editarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo !== "ARQUIVADO" && scope.row.statusEmpresaCodigo !== "CONCLUIDO" && scope.row.statusEmpresaCodigo !== "CANCELADO"',
                                @click.native='arquivarContrato(scope.row.id)'
                            )
                                i.mdi.mdi-archive
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.arquivar') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exportarRelatorioContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-file-download-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.exportarRelatorioContrato') }}
                            el-dropdown-item(
                                @click.native='removerContrato(scope.row)',
                                v-if='codigosRemover[scope.row.statusEmpresaCodigo]'
                            )
                                i.mdi.mdi-trash-can-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.removerContrato') }}

                            el-dropdown-item(
                                icon='el-icon-circle-close',
                                v-if='scope.row.statusEmpresaCodigo !== "ARQUIVADO" && scope.row.statusEmpresaCodigo !== "CANCELADO"',
                                @click.native='cancelarContrato(scope.row.id)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.cancelarContrato') }}
            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} {{ paginacao.total > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contratos') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contrato') }}
            span.pagina.espacamento-totalizador {{ formatNumber(totalizador) }} {{ totalizador > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorToneladas') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorTonelada') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import formatters from '@/utils/formatters';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'TabelaGestaoContratoOriginacaoEmpresa',
    components: {
        ModalDetalheAnalise
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: Number,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            codigosEdicao: {
                EM_CADASTRAMENTO: 'EM_CADASTRAMENTO',
                VISUALIZADO: 'VISUALIZADO',
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            },
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO'
            },
            contratosSelecionados: [],
            numeroContratoSelecionado: '',
            statusEmpresa: '',
            columnWidths: {},
            tableLayout: 'auto',
            ambientes: AmbientesEmpresas
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        isBe8() {
            const nameGroup = this.usuarioLogado?.nameGroup?.toUpperCase();

            return nameGroup === 'BE8';
        }
    },
    mounted() {
        this.calculateColumnWidths();

        this.$nextTick(() => {
            this.adjustTableLayout();
        });
    },
    watch: {
        tabelaData: {
            handler() {
                this.$nextTick(() => {
                    this.calculateColumnWidths();
                    this.adjustTableLayout();
                });
            },
            deep: true
        }
    },
    methods: {
        calculateColumnWidths() {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            context.font = '14px Roboto';
            const columns = {
                numeroContrato: 'Número do Contrato',
                nomeVendedor: 'Fornecedor',
                materialNome: 'Produto',
                safraNome: 'Colheita',
                volumeContratado: 'Volume Contratado',
                dataContrato: 'Data do Contrato',
                eudr: 'EUDR',
                statusEmpresa: 'Status'
            };

            Object.keys(columns).forEach(key => {
                let maxWidth = context.measureText(columns[key]).width + 40;

                this.tabelaData.forEach(item => {
                    let value = item[key] || '';

                    const textWidth =
                        context.measureText(value.toString()).width + 40;
                    if (textWidth > maxWidth) {
                        maxWidth = textWidth;
                    }
                });

                const minWidth =
                    key === 'safraNome' || key === 'eudr' ? 100 : 120;
                const maxWidthLimit = key === 'nomeVendedor' ? 350 : 300;

                this.columnWidths[key] = Math.min(
                    Math.max(maxWidth, minWidth),
                    maxWidthLimit
                );
            });
        },

        getColumnWidth(columnName) {
            return this.columnWidths[columnName] || 120;
        },

        adjustTableLayout() {
            this.$nextTick(() => {
                const table = this.$refs.multipleTable;
                if (table && table.$el) {
                    table.doLayout();
                }
            });
        },
        visualizar(contrato) {
            const numeroContrato = contrato.numeroContrato;
            const statusEmpresaCodigo = contrato.statusEmpresaCodigo;
            const tipoContratoOffline = contrato.tipoContratoOffline;
            const eudr = contrato.eudr;

            if (!tipoContratoOffline && eudr) {
                this.exibirModalPreencherContratoEudr = true;
                this.numeroContratoSelecionado = numeroContrato;
            } else {
                this.visualizarProcessamento(
                    numeroContrato,
                    statusEmpresaCodigo
                );
            }
        },
        editar(contrato) {
            const numeroContrato = contrato.numeroContrato;
            const statusEmpresaCodigo = contrato.statusEmpresaCodigo;
            const tipoContratoOffline = contrato.tipoContratoOffline;
            const eudr = contrato.eudr;

            if (!tipoContratoOffline && eudr) {
                this.editando = true;
                this.exibirModalPreencherContratoEudr = true;
                this.numeroContratoSelecionado = numeroContrato;
                this.statusEmpresa = statusEmpresaCodigo;
            } else {
                this.editarContrato(numeroContrato);
            }
        },
        continuarPreenchimentoEudr() {
            const numeroContrato = this.numeroContratoSelecionado;
            const statusEmpresaCodigo = this.statusEmpresa;
            this.exibirModalPreencherContratoEudr = false;
            if (this.editando) {
                this.editando = false;
                this.editarContrato(numeroContrato);
            } else {
                this.visualizarProcessamento(
                    numeroContrato,
                    statusEmpresaCodigo
                );
            }
        },
        fecharPreenchimentoEudr() {
            this.editando = true;
            this.exibirModalPreencherContratoEudr = false;
        },
        eudrFormatado(eudr) {
            if (eudr === null || eudr === '' || eudr === undefined) {
                return '-';
            }
            return eudr
                ? this.$t('mensagens.comuns.sim')
                : this.$t('mensagens.comuns.nao');
        },
        formatarTotal(totalizador) {
            const und =
                totalizador > 1
                    ? this.$t(
                          'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorToneladas'
                      )
                    : this.$t(
                          'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorTonelada'
                      );
            const number =
                totalizador > 0 ? formatters.formatNumber(totalizador) : 0;

            return `${number} ${und}`;
        },
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name:
                    this.usuarioLogado.ambienteLogado === 'PY'
                        ? 'VisualizarContratoOriginacaoEmpresaPY'
                        : 'VisualizarContratoOriginacaoEmpresa',
                params: { id: numeroContrato }
            });
        },
        editarContrato(numeroContrato) {
            this.$router.push({
                name:
                    this.usuarioLogado.ambienteLogado === 'PY'
                        ? 'EditarContratoOriginacaoEmpresaPY'
                        : 'EditarContratoOriginacaoEmpresa',
                params: { id: numeroContrato }
            });
        },
        async exportarRelatorioContrato(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                    )
                );
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/empresa/relatorio/exportado`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.exportarRelatorioFilename'
                                );
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroExportarRelatorio'
                                    )
                                );
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarRelatorioContratoEmpresa(
                        numeroContrato
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i>' +
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.downloadEmProcessamento'
                            ),
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                        )
                    );
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.usuarioDeslogado'
                    )
                );
                disconnect();
            }
        },
        async removerContrato(contratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarRemocaoContrato'
                ) +
                    contratoOriginacao.numeroContrato +
                    '?',
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('removerContrato', contratoOriginacao.id);
            }
        },
        async arquivarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarArquivamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('arquivarContrato', idContratoOriginacao);
            }
        },
        async cancelarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarCancelamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('cancelarContrato', idContratoOriginacao);
            }
        },
        limparRemocao() {
            this.$refs.multipleTable.clearSelection();
        },
        handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('removerContratoLote', idsContratosOriginacao);
        },
        camposSelecionaveis(row, index) {
            const selecionavel =
                row.statusEmpresaCodigo === 'CONCLUIDO' ||
                row.statusEmpresaCodigo === 'NAO_VISUALIZADO';
            return selecionavel;
        },
        formatNumber(number, decimalPlaces) {
            if (number < 1) {
                return 0;
            }
            return formatters.formatNumber(number, decimalPlaces);
        },
        formatarNumeroContrato(numeroContrato) {
            if (this.usuarioLogado.nameGroup === 'VITERRA') {
                const contratoStr = String(numeroContrato)
                    .replace(/\D/g, '')
                    .padStart(10, '0');
                const parte1 = contratoStr.slice(0, 7);
                const parte2 = contratoStr.slice(7);
                return `${parte1}-${parte2}`;
            }
            return numeroContrato;
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }

    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;

        i {
            margin-right: 2px;
        }

        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;
    }
}

.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}
</style>
